import {
  AddFuelingServiceImageRequest,
  CreateFuelingServiceCTARequest,
  CreateFuelingServiceRequest,
  GetFuelingServiceImageRequest,
  RemoveFuelingServiceCTARequest,
  RemoveFuelingServiceImageRequest,
  UpdateFuelingServiceMetadataRequest,
  UpdateFuelingServiceOperationHoursRequest,
  UpdateFuelingServicePaymentMethodsRequest,
  UpdateFuelingServiceStoreIdsRequest,
  UpdateFuelingServiceTagsRequest,
} from './requests/fueling-service-request.ts';
import { apiClient } from './client.tsx';
import {
  AddFuelingServiceImageResponse,
  CreateFuelingServiceCTAResponse,
  CreateFuelingServiceResponse,
  DisableFuelingServiceResponse,
  EnableFuelingServiceResponse,
  GetFuelingServiceImageResponse,
  GetFuelingServiceResponse,
  PauseFuelingServiceResponse,
  RemoveFuelingServiceCTAResponse,
  RemoveFuelingServiceImageResponse,
  RemoveFuelingServiceOperationHoursResponse,
  UpdateFuelingServiceMetadataResponse,
  UpdateFuelingServiceOperationHoursResponse,
  UpdateFuelingServicePaymentMethodsResponse,
  UpdateFuelingServiceStoreIdsResponse,
  UpdateFuelingServiceTagsResponse,
} from './responses/fueling-service-response.ts';

export const createFuelingService = (request: CreateFuelingServiceRequest) =>
  apiClient
    .post<CreateFuelingServiceResponse>('/v2/fueling_services', request)
    .then((res) => res.data.data);

export const updateFuelingServiceMetadata = (
  request: UpdateFuelingServiceMetadataRequest,
) =>
  apiClient
    .put<UpdateFuelingServiceMetadataResponse>(
      `/v2/fueling_services/${request.serviceId}`,
      request,
    )
    .then((res) => res.data.data);

export const getFuelingService = (serviceId: string) =>
  apiClient
    .get<GetFuelingServiceResponse>(`/v2/fueling_services/${serviceId}`)
    .then((res) => res.data.data);

export const createFuelingServiceCTA = (
  request: CreateFuelingServiceCTARequest,
) =>
  apiClient
    .post<CreateFuelingServiceCTAResponse>(
      `/v2/fueling_services/${request.serviceId}/call_to_actions`,
      request,
    )
    .then((res) => res.data.data);

export const removeFuelingServiceCTA = (
  request: RemoveFuelingServiceCTARequest,
) =>
  apiClient
    .delete<RemoveFuelingServiceCTAResponse>(
      `/v2/fueling_services/${request.serviceId}/call_to_actions/${request.callToActionId}`,
    )
    .then((res) => res.data.data);

export const disableFuelingService = (serviceId: string) =>
  apiClient
    .post<DisableFuelingServiceResponse>(
      `/v2/fueling_services/${serviceId}/disable`,
    )
    .then((res) => res.data.data);

export const enableFuelingService = (serviceId: string) =>
  apiClient
    .post<EnableFuelingServiceResponse>(
      `/v2/fueling_services/${serviceId}/enable`,
    )
    .then((res) => res.data.data);

export const addFuelingServiceImage = (
  request: AddFuelingServiceImageRequest,
) =>
  apiClient
    .post<AddFuelingServiceImageResponse>(
      `/v2/fueling_services/${request.serviceId}/images`,
      request.file,
      { headers: { 'Content-Type': 'multipart/form-data' } },
    )
    .then((res) => res.data.data);

export const removeFuelingServiceImage = (
  request: RemoveFuelingServiceImageRequest,
) =>
  apiClient
    .delete<RemoveFuelingServiceImageResponse>(
      `/v2/fueling_services/${request.serviceId}/images/${request.imageId}`,
    )
    .then((res) => res.data.data);

export const getFuelingServiceImage = (
  request: GetFuelingServiceImageRequest,
) =>
  apiClient
    .get<GetFuelingServiceImageResponse>(
      `/v2/fueling_services/${request.serviceId}/images/${request.imageId}`,
    )
    .then((res) => res.data.data);

export const updateFuelingServiceOperationHours = (
  request: UpdateFuelingServiceOperationHoursRequest,
) =>
  apiClient
    .put<UpdateFuelingServiceOperationHoursResponse>(
      `/v2/fueling_services/${request.serviceId}/operation_hours`,
      request,
    )
    .then((res) => res.data.data);

export const removeFuelingServiceOperationHours = (serviceId: string) =>
  apiClient
    .delete<RemoveFuelingServiceOperationHoursResponse>(
      `/v2/fueling_services/${serviceId}/operation_hours`,
    )
    .then((res) => res.data.data);

export const pauseFuelingService = (serviceId: string) =>
  apiClient
    .post<PauseFuelingServiceResponse>(
      `/v2/fueling_services/${serviceId}/pause`,
    )
    .then((res) => res.data.data);

export const removeFuelingService = (serviceId: string) =>
  apiClient.delete(`/v2/fueling_services/${serviceId}`);

export const updateFuelingServicePaymentMethods = (
  request: UpdateFuelingServicePaymentMethodsRequest,
) =>
  apiClient
    .put<UpdateFuelingServicePaymentMethodsResponse>(
      `/v2/fueling_services/${request.serviceId}/payment_methods`,
      request,
    )
    .then((res) => res.data.data);

export const updateFuelingServiceTags = (
  request: UpdateFuelingServiceTagsRequest,
) =>
  apiClient
    .put<UpdateFuelingServiceTagsResponse>(
      `/v2/fueling_services/${request.serviceId}/tags`,
      request,
    )
    .then((res) => res.data.data);

export const updateFuelingServiceStoreIds = (
  request: UpdateFuelingServiceStoreIdsRequest,
) =>
  apiClient
    .put<UpdateFuelingServiceStoreIdsResponse>(
      `/v2/fueling_services/${request.serviceId}/stores`,
      request,
    )
    .then((res) => res.data.data);
